import { formatCardNumber, formatPhoneNumber } from '~/shared/lib/formatter';
import { orderPriorities, orderStatuses, publicStatuses, splitParts, traderOrderStatuses } from '../constants';
import {
    Bank,
    type Status,
    type Priority,
    type TraderOrderStatus,
    type PublicStatus,
    type SplitPart,
    type TraderSplitPart,
} from '../model';

export const formatOrder = {
    date: (dateString?: string) => {
        if (!dateString) {
            return '';
        }

        return new Date(dateString).toLocaleString();
    },
    bank: (bank?: Bank) => {
        if (!bank) {
            return '';
        }

        if (typeof bank !== 'string') {
            return 'BIN банка не определен';
        }

        if (bank === Bank.BANK_UNSPECIFIED) {
            return 'Не указан';
        }

        return bank.replace('BANK_', '').replaceAll('_', ' ');
    },
    priority: (priority?: Priority) => {
        if (!priority) {
            return '';
        }

        const { label } =
            orderPriorities.find((p) => {
                return p.value === priority;
            }) ?? {};

        return label;
    },
    status: (status?: Status | TraderOrderStatus) => {
        if (!status) {
            return '';
        }

        const { label } =
            [...orderStatuses, ...traderOrderStatuses].find((p) => {
                return p.value === status;
            }) ?? {};

        return label ?? '';
    },
    publicStatus: (status?: PublicStatus) => {
        if (!status) {
            return '';
        }

        const { label } =
            publicStatuses.find((p) => {
                return p.value === status;
            }) ?? {};

        return label || '';
    },
    splitPart: (splitPart?: SplitPart | TraderSplitPart) => {
        const { label } =
            splitParts.find((p) => {
                return p.value === splitPart;
            }) ?? {};

        return label;
    },
    currency: (currency?: string) => {
        if (!currency) {
            return '';
        }

        return currency.replace('CURRENCY_', '');
    },
    type: (type: string) => {
        return type.replace('TYPE_', '').replaceAll('_', ' ');
    },
    cardNumber: formatCardNumber,
    phoneNumber: formatPhoneNumber,
} as const;
